import axios from "axios";
//const API_URL = "http://localhost:8080";
const API_URL = process.env.REACT_APP_API_URL || "https://api.fullpass.com.ar";

const _fetch = async (endpoint, onSuccess, onFailure, body, method = "get", needAuth = true) => {
  const token = (needAuth && JSON.parse(localStorage.getItem("fullpass_user"))?.token) || "";
  const headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };
  const options = {
    method,
    headers,
    url: `${API_URL}${endpoint}`,
    data: body,
  };

  try {
    const response = await axios(options);
    if (response.status >= 200 && response.status < 300) {
      onSuccess(response.data);
    } else {
      if (response.status == 406) {
        localStorage.removeItem("fullpass_user");
        window.location.reload();
      } else {
        onFailure(response);
      }
    }
  } catch (error) {
    if (error.response?.status == 406) {
      localStorage.removeItem("fullpass_user");
      window.location.reload();
    } else {
      onFailure(error.response || error);
    }
  }
};

const authUser = (user, password, onSuccess, onFailure) => {
  _fetch("/user/auth", onSuccess, onFailure, { user, password }, "post", false);
};

const renewAuthToken = (onSuccess, onFailure) => {
  _fetch("/user/auth/renew", onSuccess, onFailure, undefined, "post", true);
};

const getSelfUser = (onSuccess, onFailure) => {
  _fetch("/user/me", onSuccess, onFailure, undefined, "post", true);
};

const getSubscriptionPlans = (onSuccess, onFailure) => {
  _fetch("/subscription", onSuccess, onFailure, null, "get", false);
};

const registerUser = ({ name, lastName, email, password, dni, birthDate, gender, phone }, onSuccess, onFailure) => {
  _fetch(
    "/user",
    onSuccess,
    onFailure,
    { name, lastName, email, password, dni, birthDate, gender, phone },
    "post",
    false
  );
};

const addUserPaymentCard = ({ cardNumber, cardExpMonth, cardExpYear, subscriptionPlanId }, onSuccess, onFailure) => {
  _fetch(
    "/payment/card",
    onSuccess,
    onFailure,
    { cardNumber, cardExpMonth, cardExpYear, subscriptionPlanId },
    "post",
    true
  );
};

const getHomeGyms = ({ lat, lon }, onSuccess, onFailure) => {
  _fetch(`/gym/home/location/${lat}/${lon}`, onSuccess, onFailure, null, "get", true);
};

const getGyms = (onSuccess, onFailure) => {
  _fetch(`/gym`, onSuccess, onFailure, null, "get", true);
};

const getActiveBookings = (onSuccess, onFailure) => {
  _fetch("/booking/me/active", onSuccess, onFailure, null, "get", true);
};

const getGym = (gymId, onSuccess, onFailure) => {
  _fetch(`/gym/${gymId}`, onSuccess, onFailure, null, "get", true);
};

const makeBooking = (scheduleId, onSuccess, onFailure) => {
  _fetch(`/booking`, onSuccess, onFailure, { scheduleId }, "post", true);
};

const cancelBooking = (bookingId, onSuccess, onFailure) => {
  _fetch(`/booking/${bookingId}`, onSuccess, onFailure, undefined, "delete", true);
};

const accessGym = (qrCode, onSuccess, onFailure) => {
  _fetch(`/gym/access`, onSuccess, onFailure, { qrCode }, "post", true);
};

const getPaymentsHistory = (onSuccess, onFailure) => {
  _fetch(`/payment/me`, onSuccess, onFailure, null, "get", true);
};

const getActivePaymentCard = (onSuccess, onFailure) => {
  _fetch(`/payment/card/active`, onSuccess, onFailure, null, "get", true);
};

const cancelSubscription = (onSuccess, onFailure) => {
  _fetch(`/subscription/me`, onSuccess, onFailure, undefined, "delete", true);
};

const activateSubscription = (onSuccess, onFailure) => {
  _fetch(`/subscription/me`, onSuccess, onFailure, undefined, "post", true);
};

const getSelfSubscription = (onSuccess, onFailure) => {
  _fetch(`/subscription/me`, onSuccess, onFailure, null, "get", true);
};

const getSelfBookings = (onSuccess, onFailure) => {
  _fetch(`/booking/me`, onSuccess, onFailure, null, "get", true);
};

const api = {
  authUser,
  renewAuthToken,
  getSubscriptionPlans,
  registerUser,
  addUserPaymentCard,
  getGyms,
  getHomeGyms,
  getGym,
  getActiveBookings,
  makeBooking,
  cancelBooking,
  accessGym,
  getPaymentsHistory,
  getActivePaymentCard,
  cancelSubscription,
  getSelfSubscription,
  activateSubscription,
  getSelfBookings,
  getSelfUser,
};

export default api;
